// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { ETranslationScope, overwriteTranslations } from "@sequentech/ui-core";
var useUpdateTranslation = function (_a, defaultLanguageTouched, setDefaultLanguageTouched) {
    var electionEvent = _a.electionEvent;
    // Overwrites translations based on the election event presentation
    // Update Language based on presentation only if default language has not been touched,
    // So search param "lang" > user selected locale (saved in cookie) >
    // language detection policy (force default) > browser settings
    useEffect(function () {
        var _a;
        var hasSetDefaultLanguage = overwriteTranslations((_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) !== null && _a !== void 0 ? _a : undefined, {
            scope: ETranslationScope.VOTING_PORTAL,
            legacyScope: ETranslationScope.VOTING_PORTAL,
            changeDefaultLanguage: !defaultLanguageTouched,
        });
        if (hasSetDefaultLanguage) {
            setDefaultLanguageTouched(true);
        }
        return function () {
            overwriteTranslations(undefined, {
                scope: ETranslationScope.VOTING_PORTAL,
                legacyScope: ETranslationScope.VOTING_PORTAL,
                changeDefaultLanguage: false,
            });
        };
    }, [electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation]);
    return {};
};
export default useUpdateTranslation;
